<template>
  <div class="login-container">
    <div class="login-head">
      <img class="login-head-logo" src="../assets/images/logo.png" />
      <div class="login-head-info">
        <span @click="toKaPian">卡片消息</span>
        <span @click="toGuoJi">国际短信</span>
        <span @click="toWaiHu">语音外呼</span>
        <span @click="toWeiqu">微趣官网</span>
        <span @click="toAbout">关于我们</span>
      </div>
    </div>
    <div class="login-form">
      <img class="login-form-img" src="../assets/images/about.png" />
      <div class="login-form-box">
        <div class="title">欢迎登录</div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" style="width: 60%">
          <el-form-item prop="account">
            <div class="input-box">
              <img class="input-box-icon" src="../assets/images/userName.png" />
              <el-input placeholder="请输入账号" v-model="ruleForm.account" autocomplete="off" />
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="input-box" style="padding-top: 20px;">
              <img class="input-box-icon" src="../assets/images/password.png" />
              <el-input placeholder="请输入密码" type="password" v-model="ruleForm.password" />
            </div>
          </el-form-item>
          <el-form-item prop="code">
            <div class="input-box">
              <img class="input-box-icon" src="../assets/images/code.png" />
              <el-input placeholder="请输入验证码" v-model="ruleForm.code" />
              <img class="code-img" :src="'data:image/jpeg;base64,' + codeImg" @click="getCodeImg" />
            </div>
          </el-form-item>
          <el-form-item style="padding-top:30px;">
            <el-button type="primary" style="width:100%;height: 40px;" @click="submitForm(ruleForm)">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="foot">湖南微趣互动科技有限公司 © 2022-2025 版权所有 湘ICP备17012916号-2</div>
  </div>
</template>

<script>

import axios from '../common/axios'
export default {
  name: '',
  props: {},
  data() {
    return {
      ruleForm: {
        account: '',
        password: '',
        code: '',
      },
      codeImg: '',
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
         
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
    
        ],
      },

    }
  },
  components: {

  },
  computed: {

  },
  watch: {

  },
  methods: {

    async getCodeImg() {

      const res = await axios.get('api/login/getCaptcha')

      if (res.data.code == '0000') {

        this.codeImg = res.data.data
      }
    },
    //卡片消息
    toKaPian() {
      window.open('https://106sms.dycpaas.com/user/login')
    },
    //国际短信
    toGuoJi() {
      window.open('https://106sms.dycpaas.com/user/login')
    },
    //语音外呼
    toWaiHu() {
      window.open('https://ai.c1f.cc/#/login')
    },
    //去官网
    toWeiqu() {
      window.open('http://weiqucloud.com/')
    },
    //关于我们
    toAbout() {
      window.open('https://www.weiqucloud.com/#/about')
    },
    //登录
    async submitForm(ruleForm) {
      await this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          axios.post('api/login', this.ruleForm).then(res => {
            const roleType = res.data.data && res.data.data.roleType
            if (res.data.code == '0000') {
              window.localStorage.setItem('token', res.data.data.token)
              window.localStorage.setItem('userInfo', JSON.stringify(res.data.data))
              // this.$store.commit('SET_USERINFO',res.data.data)
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              setTimeout(() => {
                // res.data.data.roleType == 2 || res.data.data.roleType == 3
                if(res.data.data.roleType == 3){
                  this.$router.push({
                  // path: '/sending'
                  path: '/subAccountManage'
                })
                }else{
                  this.$router.push({
                  path: '/menu'
                })
                }

              }, 500);

            }
            else {
              this.$message({
                message: res.data.desc,
                type: 'error'
              })
              this.getCodeImg()
            }
          })
        } else {

        }
      });
    },


  },
  created() {
  },
  mounted() {
    this.getCodeImg()

  },
}
</script>

<style scoped lang="scss">
::v-deep .el-input__wrapper {
  box-shadow: none !important;
}

.code-img {
  width: 30%;
}

.login-container {
  background: linear-gradient(180deg, #266FEB 0%, #34AFFD 100%);
  padding: 0 15%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100vh;

  .login-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    &-logo {
      width: 195px;
      height: 46px;
    }

    &-info {
      color: #fff;

      span {
        margin-left: 50px;
        cursor: pointer;
      }
    }
  }

  .login-form {
    display: flex;
    justify-content: center;

    &-img {
      width: 50%;
    }

    &-box {
      border-radius: 0 16px 16px 0;
      background: #fff;
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .title {
        padding-bottom: 50px;
        font-size: 30px;
        font-weight: 600;
        color: #545657;
      }

      .input-box {
        box-sizing: border-box;
        width: 100%;
        // border: 1px solid #DDDFE3;
        display: flex;
        align-items: center;
        padding: 8px 6px;

        input {
          flex: 1;
          border: none;
          outline: none;
        }

        &-icon {
          margin-right: 10px;
          width: 26px;
          height: 26px;
        }
      }

      .login-btn {
        margin-top: 40px;
        background: #4486E8;
        width: 60%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
      }

      .login-btn:active {
        opacity: .5;
      }
    }
  }

  .foot {
    text-align: center;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
